<template lang="">
  <div>
    <footer>
      <div class="footer_box">
        <div class="footer_content">
          <div class="footer_logo_box">
            <img src="../assets/img/logo2.png" class="logo_img" />
            <div class="icon_box">
              <img src="../assets/img/facebook.svg" alt="" />
              <img src="../assets/img/twitter.svg" alt="" />
              <img src="../assets/img/ins.svg" alt="" />
            </div>
          </div>
          <div class="footer_link_box">
            <div class="footer_link_list_box">
              <div class="footer_link_list_title">SITEMAP</div>
              <div class="footer_link_list" @click="ChangeRouter('/')">
                Home
              </div>
              <div
                class="footer_link_list"
                @click="ChangeRouter('/proposition')"
              >
                Value Proposition
              </div>
              <div class="footer_link_list" @click="ChangeRouter('/product')">
                Product
              </div>
              <div class="footer_link_list">Login/Signup</div>
            </div>
            <div class="footer_link_list_box rr">
              <div class="footer_link_list_title">CONTACT US</div>
              <div class="footer_link_list">
                43rd and 44th Floor,East Tower Plaza, 222-3 XingminRoad,Zhujiang
                New Town, Tianhe District,Guangzhou,China
              </div>
              <div class="footer_link_list">020-37039757</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    ChangeRouter(url) {
      this.$router.push(url);
      // this.GoTop();
    },
    GoTop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>
<style lang="scss" scoped>
footer {
  width: 100%;
  background-color: #28283c;
  padding: 100px 0 80px;
  .footer_box {
    width: 1200px;
    margin: 0 auto;
    .footer_content {
      display: flex;
      justify-content: space-between;
      .footer_logo_box {
        .logo_img {
          width: 100px;
          display: block;
          margin-bottom: 24px;
        }
        .icon_box {
          display: flex;
          height: 28px;
          width: 125px;
          justify-content: space-between;
          img {
            height: 28px;
            cursor: pointer;
          }
        }
      }
      .footer_link_box {
        .footer_link_list_box {
          display: inline-block;
          vertical-align: top;
          margin-right: 92px;
          &.rr {
            margin-right: 0;
            width: 350px;
          }
          .footer_link_list_title {
            font-size: 18px;
            font-family: "ob";
            color: #f43d3d;
            margin-bottom: 60px;
          }
          .footer_link_list {
            font-size: 18px;
            font-family: "or";
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 40px;
            cursor: pointer;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
